<template>
  <el-upload
    action="#"
    :show-file-list="false"
    :http-request="selectFile"
    :accept="accepts"
    :class="size"
  >
    <div class="image">
      <img v-if="file" :src="file" />
      <img v-else-if="value" :src="value" />
    </div>

    <div class="label" v-if="size === 'small' || size === 'medium'">
      <i class="el-icon-upload2"></i>
      <span v-if="size === 'small'">
        {{ $t('IconUpload_Upload') }}
      </span>
      <span v-else-if="value || file">
        {{ $t('IconUpload_UploadNewIcon') }}
      </span>
      <span v-else>
        {{ $t('IconUpload_UploadIcon') }}
      </span>
    </div>

    <div class="button" v-if="size === 'large'">
      <i class="el-icon-upload"></i>
    </div>
  </el-upload>
</template>

<script>
import { toBase64 } from '@/core/helpers'

export default {
  name: 'IconUpload',

  props: {
    value: {
      required: true
    },

    file: {
      required: true
    },

    accepts: {
      required: false,
      type: String
    },

    size: {
      type: String,
      default: 'medium'
    }
  },

  methods: {
    async selectFile(option) {
      this.$emit('update:file', await toBase64(option.file))
    }
  }
}
</script>

<style scoped>
>>> .el-upload {
  border: 1px dashed #dbdee7;
  border-radius: 4px;
  color: #a6a6a6;
  font-size: 14px;
  position: relative;
  overflow: hidden;
}

>>> .el-upload:hover {
  background-color: #e6f3fb;
  border: 1px dashed #1d87c8;
  color: #1d87c8;
}

.small >>> .el-upload {
  width: 158px;
  height: 38px;
}

.medium {
  height: 40px;
}

.medium >>> .el-upload {
  width: 256px;
  height: 38px;
}

.large >>> .el-upload {
  width: 148px;
  height: 148px;
}

.medium .image,
.small .image {
  height: 28px;
  position: absolute;
  left: 5px;
  top: 5px;
}

.medium .image img,
.small .image img {
  height: 100%;
}

.large .image {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.large .image img {
  width: 100%;
  height: 100%;
}

.label {
  padding-left: 40px;
  padding-right: 40px;
  line-height: 38px;
  white-space: nowrap;
}

.label i {
  margin-right: 6px;
}

.button {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 50%;
  left: 50%;
  margin-left: -20px;
  margin-top: -20px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  line-height: 44px;
}

.button i {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/IconUpload.vue